export default "__VITE_ASSET__B5L$wzl6__"